/**
 * External dependencies
 */
import React from 'react';
import classNames from 'classnames';
import Moment from 'moment';
import 'moment-timezone';

/**
 * Interla dependencies
 */
import styles from './styles.scss';

const DateTime = ({ date, format = 'Do MMM, YYYY HH:mm:ss', className = 'ddmmyyyy', text='', ...rest }) => {
    let time = null;

    let dateConverted = new Date(date).getTime() / 1000;

    try {
        time = Moment.unix(dateConverted).tz('Australia/Melbourne').format(format);
    } catch (error) {
       
    }

    if (time=='Invalid date') {
        time = '-';
    }

    const classes = classNames('date', "date--" + className);
    
    return (
        <span className={classes}>
            {text}{time}
        </span>
    );
};



export default DateTime;
